// extracted by mini-css-extract-plugin
export var footer = "_ny-5";
export var fulfillmentInput = "_ny-0";
export var shipDateInput = "_ny-1";
export var shipmentModal = "_ny-2";
export var shipmentModalContent = "_ny-3";
export var tableContainer = "_ny-4";